import axios from 'axios'

class Role {
  static async get() {
    const googleTokenId = window.localStorage.getItem('googleTokenId')

    const res = await axios.get('role', {
      params: { googleTokenId },
    })

    return res.data
  }
}

export default Role
